<template>
    <div class="container -processes">
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li>Proccess</li>
        </ol>

        <div class="heading f -wrap -a-center">
            <h1 class="expand">Process</h1>

            <a v-link="{name: 'processes-add'}"
               class="btn btn-primary">
                <i class="glyphicon glyphicon-plus"></i> Ajouter un process
            </a>
        </div>

        <table class="table table-hover -processes -row-links">
            <tr>
                <th>Nom</th>
                <th>Étapes</th>
            </tr>

            <tr v-for="process in processes">
                <td><a v-link="{name: 'processes-edit', params: {id: process.id}}">
                    {{ process.name }}
                </a></td>
                <td><a v-link="{name: 'processes-edit', params: {id: process.id}}">
                    <span v-for="step in process.steps">
                        <span v-if="$index">, </span>
                        <strong>{{ $index + 1 }}</strong>. {{ step.name }}
                    </span>
                </a></td>
            </tr>
        </table>

        <loader v-show="loading" class="bigger-loader"></loader>

        <div class="load-more">
            <a href="#"
               v-if="hasNext && !loading"
               v-on:click.prevent="updateList(true)"
               class="btn btn-default">
                Charger plus
            </a>
        </div>
    </div>
</template>

<style type="text/css" scoped>
    .load-more {
        text-align: center;
    }
</style>

<script type="text/ecmascript-6">
    import {list} from '../api/processes';
    import {makeUpdateList} from '../utils';
    import Loader from '../components/Loader';

    export default {
        components: {
            Loader
        },
        data() {
            return {
                processes: [],
                loading: false,
                page: 1,
                hasNext: false
            };
        },
        methods: {
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'processes',
                fetch: async function (page) {
                    return await list(page);
                }
            })
        },
        ready() {
            this.updateList();
        }
    };
</script>



// WEBPACK FOOTER //
// Processes.vue?ab577666